<template>
  <div class="service">
    <div class="service__wrapper">
      <template v-for="(item, key) in items">
        <Menu @select="onSelect" :item="item" :key="key"/>
      </template>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/menu/Menu'

export default {
  name: 'Menus',
  components: {Menu},
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    onSelect(data) {
      this.$emit('select', data)
    }
  }
}
</script>
